import {connect} from '@store/@common';
import {coachingKpisByUser} from '@store/kpi/KpiObservation.selectors';
import {coachingPlanSkills} from '@store/coaching-plan-skills';

import {CoachingKpiEditList} from './CoachingKpiEditList';
import KpiObservationActions from '@store/kpi/KpiObservationActions';

const mapState = {
  coachingKpisByUser,
  skills: coachingPlanSkills,
};

const mapActions = {
  createObservation: KpiObservationActions.create,
  fetchCoachingKpis: KpiObservationActions.coachingKpis,
};

export default connect(CoachingKpiEditList, mapState, mapActions);
